import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/library";
import BaseButtons from "../../../base-buttons/BaseButtons";
import { colors } from "../../../../../themes/Colors";

const BarcodeScannerPdf417 = ({
  barcodeData,
  setBarcodeData,
  closeScanner,
}) => {
  const [isScanning, setIsScanning] = useState(false); // Control scanner state
  const videoRef = useRef(null); // Reference to the video element
  const reader = useRef(new BrowserMultiFormatReader()); // Barcode reader instance

  // Start scanning
  const startScanning = async () => {
    try {
      // Get the user's camera
      const videoStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });

      if (videoStream) {
        videoRef.current.srcObject = videoStream;
        videoRef.current.setAttribute("playsinline", true); // Ensures inline video play on iPhone
        videoRef.current.play();

        // Start the scanner
        reader.current.decodeFromVideoDevice(
          null,
          videoRef.current,
          (result, err) => {
            if (result) {
              if (result.getText()) {
                setBarcodeData(result.getText()); // Store the scanned barcode data
              }
            }
            if (err) {
              console.error("Scanning error:", err); // Handle errors (if any)
            }
          }
        );
      }
    } catch (error) {
      console.error("Error starting the camera:", error);
    }
  };

  // Stop scanning and clean up when the component unmounts
  const stopScanning = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      closeScanner();
      tracks.forEach((track) => track.stop()); // Stop all video tracks
    }
    reader.current.reset(); // Reset the reader
  };

  // Cleanup when the component unmounts
  useEffect(() => {
    if (isScanning) {
      startScanning(); // Start scanning when isScanning is true
    } else {
      stopScanning(); // Stop scanning when isScanning is false
    }

    return () => {
      stopScanning(); // Ensure cleanup on component unmount
    };
  }, [isScanning]);

  return (
    <div
      style={{
        textAlign: "center",
        maxWidth: "100%",
        // overflowX: "hidden",
        minWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          paddingLeft: 5,
          paddingRight: 5,
          paddingTop: 10,
          paddingBottom: 10,
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <div style={{ marginBottom: 10 }}>SCAN RC1 DOCUMENT BARCODE</div>
        <video
          ref={videoRef}
          style={{
            width: "95%",
            maxHeight: 300,
            minHeight: 200,
            border: "1px solid black",
            borderRadius: 8,
          }}
          playsInline
        />
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <BaseButtons
          onClick={() => setIsScanning(true)}
          label={"Start Scanning"}
          disabled={isScanning}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          width={"40%"}
        />

        <BaseButtons
          onClick={() => setIsScanning(false)}
          label={"Stop Scanning"}
          disabled={!isScanning}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"40%"}
        />
      </div>
      <div style={{ marginBottom: "20px" }}>
        {barcodeData ? (
          <div>
            <p>
              <strong>Scanned Data:</strong> {barcodeData}
            </p>
          </div>
        ) : (
          <p>Waiting for barcode scan...</p>
        )}
      </div>
    </div>
  );
};

export default BarcodeScannerPdf417;
